<div class="container py-4">
  <div class="row justify-content-center">
    <div class="col-lg-8">

      <div class="text-center mb-4">
        <div class="fs-1">🇩🇪</div>
        <h3 class="mt-2 fw-bold">{{ 'learnDeutschHub.title' | transloco }}</h3>
        <p class="text-muted">{{ 'learnDeutschHub.subtitle' | transloco }}</p>
      </div>

      <div class="row g-3">

        <!-- Articles & Plural practice -->
        <div class="col-12 col-md-6">
          <a routerLink="/learn-deutsch/practice"
             class="card h-100 border-0 shadow-sm text-decoration-none text-reset">
            <div class="card-body text-center py-4">
              <i class="bi bi-journal-text fs-1 text-primary"></i>
              <h5 class="fw-bold mt-3 mb-1">{{ 'learnDeutschHub.articles.title' | transloco }}</h5>
              <p class="text-muted small mb-0">{{ 'learnDeutschHub.articles.description' | transloco }}</p>
            </div>
            <div class="card-footer bg-transparent border-0 text-center pb-3">
              <span class="btn btn-primary">
                <i class="bi bi-play-fill me-1"></i>{{ 'learnDeutschHub.startBtn' | transloco }}
              </span>
            </div>
          </a>
        </div>

        <!-- Story assessment -->
        <div class="col-12 col-md-6">
          <a routerLink="/learn-deutsch/stories"
             class="card h-100 border-0 shadow-sm text-decoration-none text-reset">
            <div class="card-body text-center py-4">
              <i class="bi bi-card-text fs-1 text-success"></i>
              <h5 class="fw-bold mt-3 mb-1">{{ 'learnDeutschHub.stories.title' | transloco }}</h5>
              <p class="text-muted small mb-0">{{ 'learnDeutschHub.stories.description' | transloco }}</p>
            </div>
            <div class="card-footer bg-transparent border-0 text-center pb-3">
              <span class="btn btn-success">
                <i class="bi bi-play-fill me-1"></i>{{ 'learnDeutschHub.startBtn' | transloco }}
              </span>
            </div>
          </a>
        </div>

      </div>

      <p class="mt-4 mb-0 text-center small text-muted">
        {{ 'learnDeutschHub.wantOwnWords' | transloco }}
        <a routerLink="/register" class="fw-semibold">{{ 'learnDeutschHub.createFreeAccount' | transloco }}</a>
      </p>

    </div>
  </div>
</div>
